import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import {
  rootRouteRef,
  overviewRouteRef,
  spUsageRouteRef,
  invoiceRouteRef,
  invoiceListRouteRef,
  invoiceCreateRouteRef,
  invoiceEditRouteRef,
  termOfPaymentRouteRef,
  termOfPaymentCreateRouteRef,
  termOfPaymentEditRouteRef,
} from './routes';
import { billingApiRef, BillingClient } from './api';

export const billingPlugin = createPlugin({
  id: 'billing',
  routes: {
    root: rootRouteRef,
    overview: overviewRouteRef,
    spUsage: spUsageRouteRef,
    invoice: invoiceRouteRef,
    invoiceList: invoiceListRouteRef,
    invoiceCreate: invoiceCreateRouteRef,
    invoiceEdit: invoiceEditRouteRef,
    termOfPayment: termOfPaymentRouteRef,
    termOfPaymentCreate: termOfPaymentCreateRouteRef,
    termOfPaymentEdit: termOfPaymentEditRouteRef,
  },
  apis: [
    createApiFactory({
      api: billingApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new BillingClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const BillingOverviewPage = billingPlugin.provide(
  createRoutableExtension({
    name: 'BillingOverviewPage',
    component: () =>
      import('./components/BillingOverviewPage').then(
        m => m.BillingOverviewPage,
      ),
    mountPoint: overviewRouteRef,
  }),
);

export const BillingSpUsagePage = billingPlugin.provide(
  createRoutableExtension({
    name: 'BillingSpUsagePage',
    component: () =>
      import('./components/BillingSpUsagePage').then(m => m.BillingSpUsagePage),
    mountPoint: spUsageRouteRef,
  }),
);

export const BillingInvoicePage = billingPlugin.provide(
  createRoutableExtension({
    name: 'BillingInvoicePage',
    component: () =>
      import('./components/BillingInvoicePage').then(m => m.BillingInvoicePage),
    mountPoint: invoiceRouteRef,
  }),
);

export const TermOfPaymentListPage = billingPlugin.provide(
  createRoutableExtension({
    name: 'TermOfPaymentListPage',
    component: () =>
      import('./components/TermOfPaymentListPage').then(
        m => m.TermOfPaymentListPage,
      ),
    mountPoint: termOfPaymentRouteRef,
  }),
);

export const TermOfPaymentCreatePage = billingPlugin.provide(
  createRoutableExtension({
    name: 'TermOfPaymentCreatePage',
    component: () =>
      import('./components/TermOfPaymentCreatePage').then(
        m => m.TermOfPaymentCreatePage,
      ),
    mountPoint: termOfPaymentCreateRouteRef,
  }),
);

export const TermOfPaymentEditPage = billingPlugin.provide(
  createRoutableExtension({
    name: 'TermOfPaymentEditPage',
    component: () =>
      import('./components/TermOfPaymentEditPage').then(
        m => m.TermOfPaymentEditPage,
      ),
    mountPoint: termOfPaymentEditRouteRef,
  }),
);

export const InvoiceListPage = billingPlugin.provide(
  createRoutableExtension({
    name: 'InvoiceListPage',
    component: () =>
      import('./components/InvoiceListPage').then(m => m.InvoiceListPage),
    mountPoint: invoiceListRouteRef,
  }),
);

export const InvoiceCreatePage = billingPlugin.provide(
  createRoutableExtension({
    name: 'InvoiceCreatePage',
    component: () =>
      import('./components/InvoiceCreatePage').then(m => m.InvoiceCreatePage),
    mountPoint: invoiceCreateRouteRef,
  }),
);

export const InvoiceEditPage = billingPlugin.provide(
  createRoutableExtension({
    name: 'InvoiceEditPage',
    component: () =>
      import('./components/InvoiceEditPage').then(m => m.InvoiceEditPage),
    mountPoint: invoiceEditRouteRef,
  }),
);
